import { useGetProductsQuery as useGetShopifyProductsQuery } from "@store/services/shopify";
import { useGetUserDetailsQuery } from "@store/services/user";

import { useActiveDisabledRules, withDisabledVariantsFiltered } from "./useProducts.disabledProducts";

// Forwardable query options: `skip` is combined with internally derived conditions and
// `selectFromResult` would clash with the disabled-variant filtering.
type TProductsQueryOptions = Omit<NonNullable<Parameters<typeof useGetShopifyProductsQuery>[1]>, "selectFromResult">;

/**
 * Reads products from Shopify, hiding disabled variants for the current user.
 * Pass `withoutPartner` to fetch prices without the user's partner discount applied.
 */
export const useProducts = ({
  withoutPartner,
  ...queryOptions
}: TProductsQueryOptions & { withoutPartner?: boolean } = {}) => {
  const { data: userDetailsData } = useGetUserDetailsQuery();
  const activeRules = useActiveDisabledRules();

  const partner = withoutPartner ? undefined : userDetailsData?.partners?.[0]?.id;

  const shopify = useGetShopifyProductsQuery({ partner }, queryOptions);

  return withDisabledVariantsFiltered(shopify, activeRules);
};
